import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import routing from '../modules/routing/dux'
import questions from '../modules/questions/dux'

export default function createRootReducer(history) {
  return combineReducers({
    router: routerReducer(history),
    routing,
    questions
  })
}
